<template>
  <div class="keqiHome">
    <Header
      :tabList="tabList"
      :isEnglish="isEnglish" 
      :Selectlanguage="Selectlanguage"
      :value="selectValue"
      @change="onTabChange"
      @lang="onLanChane"
    />
    <router-view></router-view>
    <Footer
      :info="info"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import Header from "../keqi/components/header";
import Footer from "../keqi/components/footer";
import api from "@/api/api";
import { apiGet } from "@/fetch/api";
export default {
  components: {
    Header,
    Footer
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      navData: {},
      tabList: [
        {
          label: '首页',
          value: 'home',
          routeName: 'keqiHomePage',
          path: '/index',
        },
        {
          label: '全域概况',
          value: 'introduce',
          routeName: 'keqiIntroduce',
          path: '/introduce',
        },
        {
          label: '度假攻略',
          value: 'strage',
          routeName: 'keqiStrage',
          path: '/strage',
          pid: 902,
        },
        {
          label: '活动盛世',
          value: 'news',
          routeName: 'keqiActive',
          path: '/newslist',
          pid: 903,
        },
        {
          label: '信息公告',
          value: 'infor',
          routeName: 'keqiInfor',
          path: '/newslist',
          pid: 904,
        },
        {
          label: '在线预订',
          value: 'onlineBook',
          routeName: 'keqiOnlineBook',
          path: '/ticketlist',
          children: [
            {
              label: '购门票',
              value: 'ticket',
              routeName: 'keqiTicketList',
              path: '/ticketlist'
            },
            {
              label: '尝美食',
              value: 'eatery',
              routeName: 'keqiEateryList',
              path: '/eaterylist',
            },
            {
              label: '买特产',
              value: 'shop',
              routeName: 'keqiShopList',
              path: '/shoplist',
            },
          ]
        },
      ],
      selectValue: 'keqiHomePage',
      ticketList: [],
      shopList: [],
      isEnglish: false,
      Selectlanguage: 'chinese',
      info: {},
    };
  },
   computed: {
    ...mapState("privateConfig", ["pageWidth"])
  },
  created () {
    this.initNav();
    this.getInfo();
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      //在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    // 菜单切换(更换 前端菜单写死)
    onTabChange(data) {
      this.selectValue = data.routeName;
      localStorage.setItem('selectValue', data.routeName);
      if (data.linkUrl === 'customlink') { // 自定义链接跳转
        window.location.href = data.customLinkurl;
      } else if (data.linkUrl === 'home') { // 首页路由跳转
        this.$router.push({
          name: 'keqiHomePage',
        });
      } else if (data.linkUrl === 'ticket') { // 景区简介路由跳转
        this.$router.push({
          name: 'keqiIntroduce',
        });
      } else if(data.routeName === 'keqiHomePage') { // 首页
        this.$router.push({
          path: '/',
        });
      } else if(data.routeName === 'keqiIntroduce') { // 景区
        this.$router.push({
          path: '/introduce',
          query: {
            pid: 2476,
            menuId: 899,
            m_id: this.$route.query.m_id,
          }
        });
      } else if(['度假攻略', '活动盛世', '信息公告'].includes(data.label)) {
        localStorage.setItem('news_title', data.label)
        this.$router.push({
          path: '/newslist',
          query: {
            pid: data.pid,
            m_id: this.$route.query.m_id,
          }
        });
      } else if(data.routeName === 'keqiOnlineBook') { // 在线预订
        localStorage.setItem('news_title', '在线预订')
      } else {
        this.$router.push({
          name: data.routeName,
        });
      }
    },
    onLanChane(type){
      if(type==='chinese'){
        this.isEnglish=false;
      }
      if(type==='English'){
        this.isEnglish=true;
      }
      this.Selectlanguage=type;
    },
    // 获取header、footer 信息
    getInfo() {
      const url = api.main.getMerchantInfo;
      const params = {
        merchantInfoId: this.$route.query.m_id
      }
      apiGet(url, params).then(res => {
        this.info = res.data;
      });
    },
    // 获取导航菜单
    initNav() {
      let customUrl = api.main.getUsePage;
      apiGet(customUrl, {
        pageType: "pcPage",
        useRange: "pcWebsite"
      }).then(res => {
        if (res.data && res.data.content) {
          try {
            this.navData = JSON.parse(res.data.content);
          } catch (error) {
            this.navData = {};
          }
        }
      });
    },
  }
}
</script>
<style scoped>
.keqiHome{
  width: 100%;
  overflow: hidden;
  background: #f7f7f7;
}
</style>


// WEBPACK FOOTER //
// src/pages/keqi/index.vue